import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Link } from 'formlabs-web-components/Link';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import './Press.module.css';

import { withTranslation } from 'react-i18next';

const PressReleasesList = DisplayComponent(
  class PressReleasesList extends PureComponent {
    render() {
      const {
        classes,
        styleNames,
        styles,
        posts,
        t,
        page,
        hasNext,
        hasPrev
      } = this.props;

      const prev = parseInt(page, 10) - 1;
      const next = parseInt(page, 10) + 1;

      const listItems = posts.map(post => (
        <li>
          <Link key={post.id} to={post.slug}>
            <span styleName="date">{post.pub_date}</span>
            {post.title}
            <i className="fl-arrow-right" />
          </Link>
        </li>
      ));

      return (
        <div
          className={classes}
          styleName={classNames(styleNames)}
          style={styles}
        >
          <ul styleName="press_list">{listItems}</ul>
          <div styleName="pagination-wrapper">
            {hasPrev && (
              <Button
                color="light"
                rel="prev"
                url={prev > 0 ? `?page=${prev}` : null}
              >
                <i className="fl-arrow-left" /> {t('Previous')}
              </Button>
            )}
            {hasNext && (
              <Button color="light" rel="next" url={`?page=${next}`}>
                {t('Next')} <i className="fl-arrow-right" />
              </Button>
            )}
          </div>
        </div>
      );
    }
  }
);

export default withTranslation()(PressReleasesList);
